module.exports = __webpack_public_path__ + "static/media/badge8.58142141.svg";